import { createSlice } from "@reduxjs/toolkit";
import { createMaterialAPI } from "../../services/createMaterial";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const createMaterialSlice = createSlice({
  name: "createMaterial",
  initialState: data,
  reducers: {
    createMaterialInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    createMaterialInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = action?.payload?.message || "Material created successfully";
      state.error = "";
    },
    createMaterialInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      const p = action.payload;
      state.error =
        typeof p === "string"
          ? p
          : p?.message != null
            ? String(p.message)
            : Array.isArray(p?.errors)
              ? p.errors.map(String).join(" ")
              : p != null
                ? String(p)
                : "Something went wrong";
      state.data = null;
    },
    createMaterialInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const createMaterialHandler = (payload) => async (dispatch) => {
  try {
    dispatch(createMaterialAction.createMaterialInfo());
    const response = await createMaterialAPI(payload);
    dispatch(createMaterialAction.createMaterialInfoSuccess(response));
  } catch (e) {
    const raw =
      typeof e === "string"
        ? e
        : e?.response?.data?.message ?? e?.message ?? e;
    dispatch(createMaterialAction.createMaterialInfoFailure(raw));
  }
};

export default createMaterialSlice.reducer;
export const createMaterialAction = createMaterialSlice.actions;
